interface IProps {
    width?: number;
    height?: number;
}

export const PauseIcon = (props: IProps) => {
    const {width, height} = props;
    return (<svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || 16}
        height={height || 16}
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M0.5 15.5205H4.66667V0.520508H0.5V15.5205ZM11.3333 0.520508V15.5205H15.5V0.520508H11.3333Z"
            fill="#FCFCFC"
        />
    </svg>);
}